/* eslint-disable */
export default {
    
    finalize() {
      
      const pageId = document.querySelector('#configurator-container-step-1').dataset.pageId;
      const path1Button = document.querySelector('#paths__button-1');
      const path2Button = document.querySelector('#paths__button-2');
      const data = {
        step: '',
        pageId: pageId
      }
      const step1Container = document.querySelector('#configurator-container-step-1');
      const step2Container = document.querySelector('#configurator-container-step-2');
      const step3Container = document.querySelector('#configurator-container-step-3');
      const pathnameStep1 = vidoq_script_data.ajaxurl + '?action=config_step1';
      const pathnameStep2 = vidoq_script_data.ajaxurl + '?action=config_step2';
      const pathnameStep3 = vidoq_script_data.ajaxurl + '?action=submit_config';

      if (path1Button) {
        path1Button.addEventListener('click', () => {
          data['step'] = 'step1-path1';
          sendStep1Data();

          document.querySelector('#configurator-container-step-1').scrollIntoView();
        });
      }

      if (path2Button) {
        path2Button.addEventListener('click', () => {
          data['step'] = 'step1-path2';
          sendStep1Data();

          document.querySelector('#configurator-container-step-1').scrollIntoView();
        });
      }

      const sendStep1Data = () => {
  
        fetch(pathnameStep1, {
          method: 'POST',
          mode: 'cors',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        })
          .then(function (response) {
              if (response.ok) {
                  const responseText = response.text();
                  return responseText;
              }
              return Promise.reject(response);
          }).then(function (data) {
              step1Container.innerHTML = data;
              initContactForm();
              bindListenersToStep2();
              bindFormListeners();
              step2Container.innerHTML = '';
              step3Container.innerHTML = '';
          }).catch(function (error) {
              console.warn('Error', error);
          });
      
      }

      function initContactForm() {
        document.querySelectorAll(".wpcf7 > form").forEach((
          function(e){
            return wpcf7.init(e)
          }
        ));
      }
      
      const bindListenersToStep2 = () => {
        const planButton1 = document.querySelector('#config-plan__option-1');
        const planButton2 = document.querySelector('#config-plan__option-2');
        const planButton3 = document.querySelector('#config-plan__option-3');

        if (planButton1) {
          planButton1.addEventListener('click', () => {
            data['step'] = 'step2-path1';
            sendStep2Data();

            document.querySelector('#configurator-container-step-2').scrollIntoView();
          })
        }
        if (planButton2) {
          planButton2.addEventListener('click', () => {
            data['step'] = 'step2-path2';
            sendStep2Data();

            document.querySelector('#configurator-container-step-2').scrollIntoView();
          })
        }
        if (planButton3) {
          planButton3.addEventListener('click', () => {
            data['step'] = 'step2-path3';
            sendStep2Data();

            document.querySelector('#configurator-container-step-2').scrollIntoView();
          })
        }
      }

      const sendStep2Data = () => {
  
        fetch(pathnameStep2, {
          method: 'POST',
          mode: 'cors',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        })
          .then(function (response) {
              if (response.ok) {
                  const responseText = response.text();
                  return responseText;
              }
              return Promise.reject(response);
          }).then(function (data) {
              step2Container.innerHTML = data;
              initContactForm();
              bindConfigSubmit();
              bindConfigSelectListeners();
              bindFormListeners();
              bindMeasurementListener();
              step3Container.innerHTML = '';
          }).catch(function (error) {
              console.warn('Error', error);
          });
      
      }

      const bindMeasurementListener = () => {
        const select = Array.from(document.querySelectorAll('.configurator__measurement-option'));
        const storeys = Array.from(document.querySelectorAll('.configurator__storeys-wrapper'));

        if (select) {
          select.forEach(radio => {
            radio.addEventListener('change', () => {
              const selectedOption = radio.dataset.option;

              storeys.forEach((storey, index) => {
                if (index == selectedOption) {
                  storey.style.display = 'block';
                } else {
                  storey.style.display = 'none';
                }
              })  
            })
          })
        }
      }

      const bindConfigSelectListeners = () => {
        const selects = Array.from(document.querySelectorAll('.configurator__options-select'));

        // if (selects) {
        //   selects.forEach(select => {
        //     select.addEventListener('change', () => {
        //       // const selectedOption = select.options[select.selectedIndex];

        //       select.nextElementSibling ? select.nextElementSibling.remove() : null;
              
        //       // if (selectedOption.dataset.addedOption) {
                
        //       //   const addedOption = createAdditionalOption(selectedOption);

        //       //   insertAfter(addedOption, select);

        //       // } 

        //     })

            // const createAdditionalOption = selectedOption => {
            //   const addedOption = document.createElement('div');
            //   addedOption.innerHTML = 
            //     `<input type="checkbox" id="${ select.id }-added" name="${ selectedOption.dataset.addedOption }" value="${ selectedOption.dataset.addedOption }" data-price="${ selectedOption.dataset.addedPrice }">
            //     <label for="${ select.id }-added" class="configurator__title options__checkbox-label">${ selectedOption.dataset.addedOption }</label>`;
      
            //   addedOption.classList.add('additional-option-wrapper');

            //   return addedOption;
            // }

            // const selectedOption = select.options[select.selectedIndex];

            // if (selectedOption.dataset.addedOption) {
                
            //   const addedOption = createAdditionalOption(selectedOption);

            //   insertAfter(addedOption, select);

            // } 

          // })
        // }
      }

      const insertAfter = (newNode, existingNode) => {
        existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
      }

      let configData = {
        pageId: pageId,
        pdfData: {},
      };

      const bindConfigSubmit = () => {
        const configForm = document.querySelector('#configurator-form');

        if (configForm) {
          configForm.addEventListener('submit', e => {
            e.preventDefault();
            
            const data = new FormData(e.target);

            configData.pdfData = Object.fromEntries(data.entries());
            
            submitConfig();
            
          })
        }
      }

      const submitConfig = () => {
  
        fetch(pathnameStep3, {
          method: 'POST',
          mode: 'cors',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(configData),
        })
          .then(function (response) {
              if (response.ok) {
                  const responseText = response.text();
                  return responseText;
              }
              return Promise.reject(response);
          }).then(function (data) {
            step3Container.innerHTML = data;
            initContactForm();
            document.querySelector('#configurator-container-step-3').scrollIntoView();
            bindFormListeners();
          }).catch(function (error) {
              console.warn('Error', error);
          });
      
      }


      const bindFormListeners = () => {
        const inputs = Array.from(document.querySelectorAll('.wpcf7-form-control'));
        
        if (inputs) {
          inputs.forEach(input => {
            input.addEventListener('focus', () => {
              input.labels[0].classList.add('contact__form-label--active');
            })
            input.addEventListener('blur', () => {
              if (!input.value) {
                input.labels[0].classList.remove('contact__form-label--active');
              }
            })
          })
        }

        const form = document.querySelector('.wpcf7');

        if (form) {
          form.addEventListener('wpcf7mailsent', () => {
            inputs.forEach(input => {
              input.labels[0].classList.remove('contact__form-label--active');
            })
          })
        }
      }
      

    },
  };


// WEBPACK FOOTER //
// ./scripts/routes/templateConfigurator.js